import React from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import routes from './routes';
import './App.scss';

const AppRoutes = () => {
  const routeElements = useRoutes(routes);
  return routeElements;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
